// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qtdH","placeholdersHeader":"styles_placeholdersHeader__3ULy3","editorStyle":"styles_editorStyle__RRngh","placeholdersBox":"styles_placeholdersBox__1E0eJ"};